<template>
  <div v-if="broadcast" class="mt-5">
    <v-btn flat @click="onBack">
      <i class="fas fa-chevron-left mr-1"></i>
      {{ $t('Back') }}
    </v-btn>
    <v-container>
      <h2>{{ $t('Broadcast Detail') }}</h2>
    </v-container>

    <template v-if="broadcast">
      <v-container>
        <div>{{ $t('Broadcast Name') }}</div>
        <div class="primary--text">{{ name }}</div>
      </v-container>
      <v-container v-if="filter.app !== 'line' && filter.app !== 'line-broadcast'">
        <v-divider></v-divider>
        <div>{{ $t('Message Type') }}</div>
        <div class="primary--text" v-if="sendtype == 'subscription'">{{ $t('Subscription') }}</div>
        <div class="primary--text" v-else-if="sendtype == 'promotion'">
          {{ $t('Promotional Message (within 24 hours)') }}
        </div>
        <div class="primary--text" v-else-if="sendtype == 'ACCOUNT_UPDATE'">
          {{ $t('Account Update') }}
        </div>
        <div class="primary--text" v-else-if="sendtype == 'CONFIRMED_EVENT_UPDATE'">
          {{ $t('Confirmed Event Update') }}
        </div>
        <div class="primary--text" v-else-if="sendtype == 'POST_PURCHASE_UPDATE'">
          {{ $t('Post-Purchase Update') }}
        </div>
        <div class="primary--text" v-else>
          {{ $t(sendtype) }}
        </div>
      </v-container>
      <v-divider></v-divider>
      <v-container>
        <div>{{ $t('Notification Setting') }}</div>
        <div class="primary--text" v-if="pushtype == 'REGULAR'">{{ $t('Regular Push') }}</div>
        <div class="primary--text" v-else-if="pushtype == 'SILENT_PUSH'">
          {{ $t('Silent Push') }}
        </div>
        <div class="primary--text" v-else-if="pushtype == 'NO_PUSH'">{{ $t('No Push') }}</div>
      </v-container>
      <v-divider></v-divider>
      <v-container>
        <div>{{ $t('Target') }}</div>
        <div>
          <template v-if="groupType == ''">
            <div class="primary--text mt-3">{{ $t('All') }}</div>
          </template>
          <template v-else-if="groupType == 'facebook'">
            <div class="primary--text mt-3">{{ $t('Facebook') }}</div>
          </template>
          <template v-else-if="groupType == 'line'">
            <div class="primary--text mt-3">{{ $t('Line (Friends)') }}</div>
          </template>
          <template v-else-if="groupType == 'line-group'">
            <div class="primary--text mt-3">{{ $t('Line (Group)') }}</div>
          </template>
          <template v-else-if="groupType == 'line-broadcast'">
            <div class="primary--text mt-3">{{ $t('Line') }}</div>
            <div>
              <strong>{{
                $t('Broadcast to all LINE users without relying on ZWIZ.AI users')
              }}</strong>
            </div>
            <small>{{ $t('Remark') + ': ' + $t('Messages sent will not be counted') }}</small>
          </template>
          <template v-else-if="groupType == 'instagram'">
            <div class="primary--text mt-3">{{ $t('instagram') }}</div>
          </template>
          <template v-else-if="groupType == 'google'">
            <div class="primary--text mt-3">{{ $t('google') }}</div>
          </template>
          <template v-else-if="groupType == 'customize'">
            <div class="mt-3" style="border: 1px solid #eee; border-radius: 10px">
              <table class=" table">
                <tr>
                  <td>{{ $t('name') }}</td>
                  <td class="primary-color">{{ filter.fullname ? filter.fullname : '-' }}</td>
                </tr>
                <tr class="grey lighten-4">
                  <td>{{ $t('Channel') }}</td>
                  <td class="primary-color">
                    <span style="color: #3b5998" v-if="filter.app == 'facebook'">
                      <i class="fab fa-facebook-square"></i> Facebook
                    </span>
                    <span
                      style="color: #00c300"
                      v-else-if="
                        filter.app == 'line' ||
                          filter.app == 'line-broadcast' ||
                          filter.app == 'line-group'
                      "
                    >
                      <i class="fab fa-line"></i> Line
                    </span>
                    <span style="color: #C13584" v-else-if="filter.app == 'instagram'">
                      <i class="fab fa-instagram"></i> Instagram
                    </span>
                    <span style="color: #F4B400;" v-else-if="filter.app == 'google'">
                      <i class="fab fa-google"></i>
                      google
                    </span>
                    <span v-else>{{ $t('All') }}</span>
                  </td>
                </tr>
                <tr
                  class="grey lighten-4"
                  v-if="filter.app == 'line' || filter.app == 'line-group'"
                >
                  <td>{{ $t('types') }}</td>
                  <td class="primary-color">{{ filter.app == 'line' ? 'Friends' : 'Group' }}</td>
                </tr>
                <tr>
                  <td>{{ $t('gender') }}</td>
                  <td class="primary-color">
                    <template v-if="filter.gender == 'male'">{{ $t('Male') }}</template>
                    <template v-else-if="filter.gender == 'female'">{{ $t('Female') }}</template>
                    <template v-else-if="filter.gender == 'all'">{{ $t('All') }}</template>
                  </td>
                </tr>
                <tr class="grey lighten-4">
                  <td>{{ $t('Locale') }}</td>
                  <td class="primary-color">
                    <template v-if="filter.locale && filter.locale.length > 0">
                      <span v-for="(locale, index) in filter.locale" :key="'locale_' + index">
                        <flag :iso="locale.icon" />
                        {{ locale.title }}
                        <template v-if="index != filter.locale.length - 1">,</template>
                      </span>
                    </template>
                    <template v-else>-</template>
                  </td>
                </tr>

                <tr>
                  <td>{{ $t('Conversation') }}</td>
                  <td class="primary-color">
                    <template v-if="filter.intent && filter.intent.length > 0">
                      <span v-for="(intent, index) in filter.intent" :key="'intent_' + index">
                        {{ intent }}
                        <template v-if="index != filter.intent.length - 1">,</template>
                      </span>
                    </template>
                    <template v-else>-</template>
                  </td>
                </tr>
                <tr class="grey lighten-4">
                  <td>{{ $t('Email') }}</td>
                  <td class="primary-color">{{ filter.email ? filter.email : '-' }}</td>
                </tr>
                <tr>
                  <td>{{ $t('phone no.') }}</td>
                  <td class="primary-color">{{ filter.phoneno ? filter.phoneno : '-' }}</td>
                </tr>

                <!-- <tr v-if="filter.messagesent.value != '' || filter.messagesent.value != null">
                <td>{{$t('Message Sent')}}</td>
                <td
                  class="primary-color"
                >{{filter.messagesent.symbol == 'g__' ? $t('Greater than') : (filter.messagesent.symbol == 'l__' ? $t('Less than') : $t('Not'))}} {{filter.messagesent.value}}</td>
              </tr>-->
                <tr
                  class="grey lighten-4"
                  v-if="filter.registerDate.start || filter.registerDate.end"
                >
                  <td>{{ $t('First Conversation at') }}</td>
                  <td class="primary-color">
                    <template v-if="filter.registerDate.start"
                      >{{ filter.registerDate.start | DateFormat('DD/MM/YYYY') }} -</template
                    >
                    <template v-if="filter.registerDate.end">{{
                      filter.registerDate.end | DateFormat('DD/MM/YYYY')
                    }}</template>
                  </td>
                </tr>
                <tr class="grey lighten-4">
                  <td>{{ $t('Last Conversation at') }}</td>
                  <td class="primary-color">
                    <div v-if="filter.activeDate.start || filter.activeDate.end">
                      <template v-if="filter.activeDate.start"
                        >{{ filter.activeDate.start | DateFormat('DD/MM/YYYY') }} -</template
                      >
                      <template v-if="filter.activeDate.end">{{
                        filter.activeDate.end | DateFormat('DD/MM/YYYY')
                      }}</template>
                    </div>
                    <div v-else>-</div>
                  </td>
                </tr>
                <tr>
                  <td>{{ $t('Tag') }} Include</td>
                  <td class="primary-color">
                    {{ filter.tags_include ? filter.tags_include : '-' }}
                  </td>
                </tr>
                <tr>
                  <td>{{ $t('Tag') }} Exclude</td>
                  <td class="primary-color">
                    {{ filter.tags_exclude ? filter.tags_exclude : '-' }}
                  </td>
                </tr>
                <tr class="grey lighten-4">
                  <td>{{ $t('Status') }}</td>
                  <td class="primary-color">{{ filter.status ? filter.status : '-' }}</td>
                </tr>
              </table>
            </div>
          </template>
        </div>
      </v-container>
      <v-divider></v-divider>
      <v-container>
        <div>
          {{ $t('Replace a new status for this broadcast') }}
          <v-premium-lock :inline="true"></v-premium-lock>
        </div>
        <div class="mt-1 primary--text">
          {{ update_status ? update_status : '-' }}
        </div>

        <div class="mt-3">
          {{ $t('Add tag for this broadcast') }} <v-premium-lock :inline="true"></v-premium-lock>
        </div>

        <div class="primary--text" v-if="update_tags.length == 0">
          {{ $t('No tag') }}
        </div>
        <template v-else>
          <template v-for="(tag, tindex) in update_tags">
            <v-chip :key="`tags_${tindex}`" class="white--text" disabled small color="primary">
              {{ tag }}
            </v-chip>
          </template>
        </template>
      </v-container>
      <template>
        <v-divider></v-divider>
        <v-container>
          <div>{{ $t('Rebroadcast') }} <v-premium-lock :inline="true"></v-premium-lock></div>
          <div
            class="primary--text"
            v-if="$store.getters.getPackage !== 'premium' || isCoachlab || !broadcastItems.length"
          >
            -
          </div>
          <template v-else>
            <template v-for="(broadcast, tindex) in broadcastItems">
              <v-chip
                :key="`broadcast_${tindex}`"
                class="white--text"
                disabled
                small
                color="primary"
              >
                {{ broadcast.name }}
              </v-chip>
            </template>
          </template>
        </v-container>
        <v-divider></v-divider>
      </template>
      <v-divider></v-divider>
      <template v-if="broadcast.isschedule">
        <v-container>
          <div>{{ $t('Schedule Broadcast') }}</div>
          <div class="primary--text">
            {{ broadcast.scheduletime | dateFormat('DD/MM/YYYY hh:mm A') }}
          </div>
        </v-container>
        <v-divider></v-divider>
      </template>
      <v-container>
        <div style="overflow: auto">
          <template v-if="type == 'text'">
            <div>
              <message-viewer v-model="message" style="float: left"></message-viewer>
            </div>
            <div class="clearfix"></div>
          </template>
          <template v-else-if="type == 'template'">
            <generic-viewer v-model="generics" style="float: left"></generic-viewer>
            <div class="clearfix"></div>
          </template>
          <template v-if="type == 'json'">
            <message-viewer v-model="messages" style="float: left"></message-viewer>
          </template>
        </div>

        <template v-if="quick_reply.length > 0">
          <ul class="tags">
            <li class="tag" v-for="(reply, index) in quick_reply" :key="'reply_' + index">
              {{ reply }}
            </li>
          </ul>
        </template>
      </v-container>
      <v-divider></v-divider>
      <template
        v-if="
          loadingLog ||
            logs.facebook.length > 0 ||
            logs.line.length > 0 ||
            logs.instagram.length > 0 ||
            logs.google.length > 0
        "
      >
        <v-container>
          <div class="text-xs-center" v-if="loadingLog">
            <div class="spinner text-xs-center">
              <img class="z-loop" src="/static/img/assets/loading/z-loop.png" alt="loading" />
            </div>
          </div>
          <template v-else>
            <v-btn
              @click="currentLog = 'facebook'"
              depressed
              :outline="currentLog != 'facebook'"
              small
              v-if="logs.facebook.length > 0"
              :color="currentLog == 'facebook' ? 'primary' : 'grey'"
            >
              Facebook
            </v-btn>
            <v-btn
              @click="currentLog = 'line'"
              depressed
              :outline="currentLog != 'line'"
              small
              v-if="logs.line.length > 0"
              :color="currentLog == 'line' ? 'primary' : 'grey'"
            >
              LINE
            </v-btn>
            <v-btn
              @click="currentLog = 'instagram'"
              depressed
              :outline="currentLog != 'instagram'"
              small
              v-if="logs.instagram.length > 0"
              :color="currentLog == 'instagram' ? 'primary' : 'grey'"
            >
              Instagram
            </v-btn>
            <v-btn
              @click="currentLog = 'google'"
              depressed
              :outline="currentLog != 'google'"
              small
              v-if="logs.google.length > 0"
              :color="currentLog == 'google' ? 'primary' : 'grey'"
            >
              Google
            </v-btn>
            <div
              class="mt-3"
              style="border: 1px solid #eee; border-radius: 10px; overflow: auto; max-height: 500px"
            >
              <table class="table">
                <tr
                  v-for="(log, index) in logs[currentLog]"
                  :key="index"
                  :class="{ 'grey lighten-4': index % 2 == 0 }"
                >
                  <template v-if="currentLog == 'facebook' || currentLog == 'instagram'">
                    <td>{{ log.error.type }}</td>
                    <td>
                      {{ log.error.message }}
                    </td>
                  </template>
                  <template v-else-if="currentLog == 'google'">
                    <td>
                      {{ log.message }}
                    </td>
                  </template>
                  <template v-else-if="currentLog === 'line'">
                    <td>
                      <pre>{{ formatLINEErrorLog(log) }}</pre>
                    </td>
                  </template>
                  <template v-else>
                    <td>
                      {{ log.error }}
                    </td>
                  </template>
                </tr>
              </table>
            </div>
          </template>
        </v-container>
        <v-divider></v-divider>
      </template>
      <template v-if="filter.app === 'line' || filter.app === 'line-broadcast'">
        <v-container>
          <div>
            <strong>{{ $t('line_broadcast_stat') }}</strong>
            <v-premium-lock :inline="true"></v-premium-lock>
          </div>
          <small class="mt-2">{{ $t('remark_broadcast_line') }}</small>
          <div class="mt-3" style="border: 1px solid #eee; border-radius: 10px">
            <table class="table">
              <tr>
                <td>สถิติคนอ่านทั้งหมด</td>
                <td>
                  {{
                    lineBroadcastStat &&
                    lineBroadcastStat.overview &&
                    lineBroadcastStat.overview.uniqueImpression
                      ? lineBroadcastStat.overview.uniqueImpression
                      : 0
                  }}
                  user(s)
                </td>
              </tr>
              <tr>
                <td>สถิติคนคลิกทั้งหมด</td>
                <td>
                  {{
                    lineBroadcastStat &&
                    lineBroadcastStat.overview &&
                    lineBroadcastStat.overview.uniqueClick
                      ? lineBroadcastStat.overview.uniqueClick
                      : 0
                  }}
                  user(s)
                </td>
              </tr>
            </table>
          </div>
        </v-container>
      </template>
      <v-container class="text-xs-center">
        <v-btn outline color="grey" @click="onBack">
          <i class="fas fa-chevron-left mr-1"></i>
          {{ $t('Back') }}
        </v-btn>
      </v-container>
    </template>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import dayjs from 'dayjs'
import config from '@/config'
import GenericViewer from '@/components/elements/GenericViewer'
import MessageViewer from '@/components/elements/MessageViewer'
import api from '@/api'

export default {
  props: ['value'],
  data: function() {
    return {
      broadcast: undefined,
      update_status: '',
      update_tags: [],
      isSave: false,
      isFail: false,
      name: '',
      localeOptions: config.locale,
      intents: [],
      type: 'text',
      groupType: '',
      sendtype: 'subscription',
      pushtype: 'regular',
      message: '',
      quick_reply: [],
      typeOptions: [
        {
          value: 'text',
          name: 'Text'
        },
        {
          value: 'template',
          name: 'Generic'
        }
      ],
      generics: [
        {
          image_url: null,
          title: '',
          subtitle: '',
          buttons: [],

          enable: true
        }
      ],
      messages: [],
      filter: {
        fullname: '',
        gender: 'all',
        locale: null,
        app: 'all',
        intent: null,
        email: '',
        phoneno: '',
        messagesent: {
          value: null,
          symbol: ''
        },
        timezone: {
          from: -12,
          to: 14
        },
        activeDate: {
          enable: false,
          start: '',
          end: ''
        },
        registerDate: {
          enable: false,
          start: null,
          end: null
        }
      },
      loadingLog: true,
      logs: {
        facebook: [],
        line: [],
        instagram: [],
        google: []
      },
      currentLog: 'facebook',
      lineBroadcastStat: null,
      excludeIds: [],
      broadcastItems: []
    }
  },
  components: {
    GenericViewer,
    MessageViewer
  },
  async mounted() {
    // vm.getIntent(function () {})

    this.reset()
    this.loadingLog = true
    if (['facebook', 'all'].includes(this.filter.app)) {
      const fb_response = await this.get_fb_broadcast_errors()
      if (fb_response.data) {
        this.logs.facebook = fb_response.data
      }
    }
    if (['line', 'line-broadcast', 'all'].includes(this.filter.app)) {
      const line_response = await this.get_line_broadcast_errors()
      if (line_response.data) {
        this.logs.line = line_response.data
      }
      await this.getLineBroadcastStat()
    }
    if (['instagram', 'all'].includes(this.filter.app)) {
      const ig_response = await this.get_instagram_broadcast_errors()
      if (ig_response.data) {
        this.logs.instagram = ig_response.data
      }
    }

    if (['google', 'all'].includes(this.filter.app)) {
      const google_response = await this.get_google_broadcast_errors()
      if (google_response.data) {
        this.logs.google = google_response.data
      }
    }

    if (this.logs.facebook.length > 0) {
      this.currentLog = 'facebook'
    } else if (this.logs.line.length > 0) {
      this.currentLog = 'line'
    } else if (this.logs.instagram.length > 0) {
      this.currentLog = 'instagram'
    } else if (this.logs.google.length > 0) {
      this.currentLog = 'google'
    }
    this.loadingLog = false
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      isCoachlab: 'isCoachlab'
    })

    // filterIntent: function () {
    //   var vm = this
    //   vm.intents.sort(function (a, b) {
    //     var nameA = a.intentname.toUpperCase() // ignore upper and lowercase
    //     var nameB = b.intentname.toUpperCase() // ignore upper and lowercase
    //     if (a.intentname[0] === '{' && a.intentname[a.intentname.length - 1] === '}') {
    //       return 1
    //     }
    //     if (b.intentname[0] === '{' && b.intentname[b.intentname.length - 1] === '}') {
    //       return -1
    //     }
    //     if (nameA < nameB) {
    //       return -1
    //     }
    //     if (nameA > nameB) {
    //       return 1
    //     }

    //     // names must be equal
    //     return 0
    //   })
    //   var intents = []
    //   if (vm.intents) {
    //     vm.intents.map(function (intent, index) {
    //       intents.push(intent.intentname)
    //     })
    //   }
    //   return intents
    // },
  },
  methods: {
    async get_google_broadcast_errors() {
      const vm = this
      let response = await vm.get(
        `get_google_broadcast_errors?ref_index=${vm.selectedBot.pageid}&broadcast_id=${vm.broadcast.id}`
      )
      return response
    },
    async getLineBroadcastStat() {
      const vm = this
      let to = dayjs(vm.broadcast.senttime)
        .add(14, 'days')
        .format('YYYYMMDD')
      let from = dayjs(vm.broadcast.senttime).format('YYYYMMDD')
      let response = await vm.get(
        `line/${vm.selectedBot.pageid}/statistics-per-unit?customAggregationUnit=ZWIZ_BROADCAST_${vm.broadcast.id}&from=${from}&to=${to}`
      )
      if (response.success) {
        vm.lineBroadcastStat = response.result
      }
    },
    async get_instagram_broadcast_errors() {
      const vm = this
      let response = await vm.get(
        `get_instagram_broadcast_errors?ref_index=${vm.selectedBot.pageid}&broadcast_id=${vm.broadcast.id}`
      )
      return response
    },
    get_fb_broadcast_errors() {
      const vm = this
      return new Promise((resolve, reject) => {
        api.get_fb_broadcast_errors(
          {
            ref_index: vm.selectedBot.pageid,
            broadcast_id: vm.broadcast.id
          },
          (err, response) => {
            if (err) {
              reject(err)
            }
            resolve(response)
          }
        )
      })
    },
    get_line_broadcast_errors() {
      const vm = this
      return new Promise((resolve, reject) => {
        api.get_line_broadcast_errors(
          {
            ref_index: vm.selectedBot.pageid,
            broadcast_id: vm.broadcast.id
          },
          (err, response) => {
            if (err) {
              reject(err)
            }
            resolve(response)
          }
        )
      })
    },
    reset: function() {
      const vm = this
      if (vm.value) {
        vm.broadcast = Object.assign({}, vm.value)
        vm.cached_broadcast = Object.assign({}, vm.value)
      }
      if (vm.broadcast) {
        var filters = vm.broadcast.m_condition.split('&')
        filters = filters.filter(el => {
          return el != null && el != ''
        })

        if (filters.length > 0) {
          var f = filters.map(function(filter, index) {
            var value = filter.split(/=(.+)/)
            if (value.length > 1) {
              switch (value[0]) {
                case 'fullname':
                case 'gender':
                case 'app':
                case 'email':
                case 'status':
                case 'tags':
                case 'tags_include':
                case 'tags_exclude':
                case 'phoneno':
                  vm.filter[value[0]] = value[1]
                  return { id: value[0], value: value[1] }
                  break
                case 'messagesent':
                  var messagesent = value[1].split('__')
                  vm.filter[value[0]] = {
                    value: messagesent[1],
                    symbol: messagesent[0] + '__'
                  }
                  return {
                    id: value[0],
                    value: {
                      value: messagesent[1],
                      symbol: messagesent[0] + '__'
                    }
                  }
                  break
                case 'locale':
                  var locales = value[1].split(',')
                  vm.filter.locale = []
                  vm.filter.locale = vm.localeOptions
                    .map((configLocal, clindex) => {
                      if (locales.includes(configLocal.value)) {
                        return configLocal
                      } else {
                        return null
                      }
                    })
                    .filter(el => {
                      return el != null
                    })
                  return { id: 'locale', value: vm.filter.locale }
                  break
                case 'intent':
                  vm.filter.intent = value[1].split(',')
                  return { id: 'intent', value: value[1].split(',') }
                  break
                case 'timestamp_from':
                  vm.filter.activeDate.start = dayjs(value[1]).toDate()
                  return { id: 'activeDate_start', value: dayjs(value[1]).toDate() }
                  break
                case 'timestamp_to':
                  vm.filter.activeDate.end = dayjs(value[1]).toDate()
                  return { id: 'activeDate_end', value: dayjs(value[1]).toDate() }
                  break
                case 'registertimestamp_from':
                  vm.filter.registerDate.start = dayjs(value[1]).toDate()
                  return { id: 'registerDate_start', value: dayjs(value[1]).toDate() }
                  break
                case 'registertimestamp_to':
                  vm.filter.registerDate.end = dayjs(value[1]).toDate()
                  return { id: 'registerDate_end', value: dayjs(value[1]).toDate() }
                  break
                case 'exclude_broadcast_ids':
                  vm.excludeIds =
                    value && value[1] ? value[1].replace(/[\[\]]/g, '').split(',') : []

                default:
                  break
              }
            }
          })

          if (
            f.length == 1 &&
            ['facebook', 'line-broadcast', 'line', 'instagram', 'google'].includes(vm.filter['app'])
          ) {
            vm.groupType = vm.filter['app']
          } else {
            vm.groupType = 'customize'
          }
        }

        vm.name = vm.broadcast.name
        vm.type = 'json'
        try {
          let quick_reply = vm.broadcast.m_quick_reply.split(',')
          vm.quick_reply = quick_reply.filter(Boolean)
        } catch (error) {}
        vm.sendtype = vm.broadcast.sendtype
        vm.pushtype = vm.broadcast.pushtype

        this.update_status = vm.broadcast.update_user_status
        try {
          this.update_tags = vm.broadcast.update_user_tags.split(',')
          this.update_tags = this.update_tags.filter(el => {
            return el != ''
          })
          // this.tagOptions = this.update_tags
        } catch (error) {}

        if (vm.broadcast.m_type == 'template') {
          vm.messages = [
            [
              {
                type: 'generic',
                data: JSON.parse(vm.broadcast.m_val),
                ratio: vm.broadcast.ratio == 'horizontal' ? 'horizontal' : 'square'
              }
            ]
          ]
        } else if (vm.broadcast.m_type == 'json') {
          vm.messages = JSON.parse(vm.broadcast.m_val)
        } else {
          var newGroup = []
          var group = vm.broadcast.m_val.split('||')
          $.each(group, function(index, messages) {
            var newMessage = []
            var group_messages = messages.split('#nl')
            $.each(group_messages, function(index, message) {
              var type = 'text'
              if (!isNaN(message)) {
                newMessage.push({
                  type: 'text',
                  text: message
                })
              } else if (vm.isJsonParseable(message)) {
                var messageParsed = JSON.parse(message)
                newMessage.push({
                  text: messageParsed.text,
                  buttons: messageParsed.buttons,
                  type: 'button'
                })
              } else if (vm.isURL(message)) {
                newMessage.push({
                  type: 'image',
                  image_url: message
                })
              } else {
                newMessage.push({
                  type: 'text',
                  text: message
                })
              }
            })
            newGroup.push(newMessage)
          })
          vm.messages = newGroup
        }
      } else {
        vm.broadcast = undefined
      }

      if (vm.excludeIds.length) {
        try {
          const payload = {
            pageid: this.selectedBot.pageid,
            broadcast_ids: vm.excludeIds.join(','),
            status: 'broadcasted'
          }
          const setData = items => {
            this.broadcastItems = [...items.map(item => ({ name: item.name, id: item.id }))]
          }
          api.getBroadcast(payload, function(error, response) {
            if (error) {
              console.error(error)
              return
            }
            if (response.data) {
              setData(response.data || [])
            }
          })
        } catch (error) {}
      }
    },
    getIntent: function(callback) {
      let vm = this
      let auth = null
      let data = {
        pageid: vm.selectedBot.pageid
      }
      api.getIntent(data, function(error, response) {
        if (error) {
          console.error(error)
          return
        }
        if (response.data) {
          var isFoundDefault = false
          $.each(response.data, function(index, val) {
            var intent = val
            intent.isShow = false
            vm.intents.push(intent)
          })
        }
        callback()
      })
    },
    onBack: function() {
      var vm = this
      vm.$emit('onClose')
    },
    formatLINEErrorLog(errorLog) {
      const _errorLog = JSON.stringify(errorLog, null, 2)
      return _errorLog.substring(1, _errorLog.length - 1)
    }
  },
  watch: {
    value: function() {
      this.reset()
    }
  }
}
</script>

<style scoped>
td {
  padding-top: 0 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/view/broadcast/BroadcastView.vue